import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDocFromServer } from 'firebase/firestore';
import firebaseConfig from './firebase-applet-config.json';

// Inicialização do Firebase OptiVelo
console.log("OptiVelo: Conectando ao Firestore no projeto gen-lang-client-0354333727...");
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, firebaseConfig.firestoreDatabaseId);

// Validar conexão com o Firestore conforme diretriz crítica
async function testConnection(retries = 3) {
  try {
    // Tentativa de leitura de um caminho público para validar conectividade e regras
    await getDocFromServer(doc(db, 'stats', 'health'));
    console.log("OptiVelo: Conexão com Firestore estabelecida com sucesso.");
  } catch (error: any) {
    if (retries > 0) {
      console.warn(`OptiVelo: Tentativa de conexão falhou, tentando novamente... (${retries} restantes)`);
      setTimeout(() => testConnection(retries - 1), 2000);
      return;
    }

    console.log("OptiVelo: Verificando status de conectividade do cliente...");
    
    if (error?.code === 'permission-denied') {
      console.log("OptiVelo: Permissão negada durnate inicialização silenciosa. Isto é normal enquanto regras estão sendo propagadas ou coleções estão vazias.");
    } else if(error instanceof Error && (error.message.includes('the client is offline') || error.message.includes('unavailable'))) {
      console.log("OptiVelo: O cliente está em modo offline ou restabelecendo conexão. Firestore sincronizará os dados automaticamente.");
    }
  }
}
testConnection();

export default app;
